import { motion } from "framer-motion";
import { STORY, STORY_INTRO, STORY_WINK } from "@/lib/content";

const fade = (d = 0) => ({ initial: { opacity: 0, y: 40 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: "-80px" }, transition: { duration: 0.9, delay: d } });

export const Story = () => (
  <section id="historia" className="bg-sand py-24 sm:py-32 scroll-mt-24" data-testid="story-section">
    <div className="max-w-[1440px] mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-16">
      <motion.div {...fade()}>
        <p className="eyebrow text-granate flex items-center gap-3"><span className="w-8 h-px bg-granate" />Nuestra historia</p>
        <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] max-w-xl" data-testid="story-title">Dos oficios, una misma mesa</h2>
        <p className="mt-6 max-w-md text-ink/70 leading-relaxed" data-testid="story-intro">{STORY_INTRO}</p>
        <div className="relative mt-14 h-[420px] max-w-[460px]">
          <img src="/brand/detalle-1.jpg" alt="Tabla de embutidos, quesos y frutas en forma de árbol" className="absolute left-0 top-0 w-[68%] h-[340px] object-cover rounded-t-full shadow-xl" data-testid="story-image-1" />
          <img src="/brand/detalle-2.jpg" alt="Ramo de novia de flores silvestres" className="absolute right-0 bottom-0 w-[48%] h-[230px] object-cover rounded-3xl border-4 border-white shadow-2xl" data-testid="story-image-2" />
        </div>
      </motion.div>
      <div>
        {STORY.map((s, i) => (
          <motion.article key={s.t} {...fade(i * 0.1)} className="border-t border-ink/10 py-10 grid grid-cols-[64px_1fr] sm:grid-cols-[80px_1fr] gap-4" data-testid={`story-block-${i + 1}`}>
            <span className="font-display italic text-5xl text-rose">0{i + 1}</span>
            <div>
              <h3 className="font-display text-3xl sm:text-4xl">{s.t}</h3>
              <p className="mt-4 text-ink/70 leading-relaxed">{s.p}</p>
            </div>
          </motion.article>
        ))}
        <motion.p {...fade(0.2)} className="border-t border-ink/10 pt-10 font-display italic text-2xl text-granate/90 leading-snug" data-testid="story-wink">{STORY_WINK}</motion.p>
      </div>
    </div>
  </section>
);
